module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_nagai-df6be4243516da681b40aecb94617cc3.png";